import { Document } from '@/model/document2/document'
import { Data } from "@/data/data"
import { Page } from '@/model/document2/page/page';
import { Surface } from '@/model/document2/page/surface/surface';
import { Design } from '@/model/document2/page/surface/design/design';
import { SVGPathData } from 'svg-pathdata';
import { ImageHelper } from './imageHelper';
import { Const } from '@/const';
import { Product } from '@/data/productCategory/product/product';
import { Paper } from '@/data/productCategory/product/paper/paper';
import { RequestHelper } from './requestHelper';
import { EncryptionHelper } from './encryptionHelper';
import { ReplaceTemplateCommand } from '@/commands/replaceTemplateCommand';
import { ProductCategory } from '@/data/productCategory/productCategory';
import { TemplateCategory } from '@/data/templateCategory/templateCategory';

import { DebugHelper } from "@/helper/debugHelper";
import { FileHelper } from './fileHelper';

// 初期化に関する処理
export class InitializeHelper
{
    // 初期ドキュメントの作成
    public static createInitializeDocument(productCode : string, rotate : number, templateId : number, isKeepRatio : boolean, designRotate : number,
        completion : (document : Document, product : Product, paper : Paper, categoryId : number, hierarchy : number) => void, error : () => void)
    {
        var postData1 = { "searchWord" : productCode };
        RequestHelper.get("get_product_category_list", postData1, (responce1) =>
        {
            try
            {
                // レスポンスをパース
                var jsonObject1 = JSON.parse(responce1);
                // カテゴリリスト取得
                var categoryList : Array<ProductCategory> = jsonObject1.data.productCategoryList;
                // リストからProduct, Paper取得
                var productAndPaper = this.getProductByProductCode(categoryList, productCode);
                if(productAndPaper == null)
                {
                    error();
                    return;
                }

                var product = productAndPaper.product;
                var paper = productAndPaper.paper;

                var document = Document.create(productAndPaper.product, productAndPaper.paper, rotate);
                // デザイン作成
                var design = document.pageList[0].getSurface(document.isReverseSurface).createNewDesign(0);

                if(templateId == 0)
                {
                    var defaultCategoryId = paper.defaultTemplateCategoryId > 0 ? paper.defaultTemplateCategoryId : product.productCategoryId;
                    var defaultHierarchy = paper.defaultTemplateCategoryId > 0 ? paper.defaultTemplateHierarchy : 0;
                    DebugHelper.trace(defaultCategoryId)
                    completion(document, product, paper, defaultCategoryId, defaultHierarchy);
                    return;
                }

                var postData2 = { "id" : "" + templateId };

                // urlからテキストを得る
                RequestHelper.get("get_template_new_content", postData2, (response2) =>
                {
                    try
                    {
                        // レスポンスをパース
                        var jsonObject2 = JSON.parse(response2);
                        // コンテンツ取得
                        var content = jsonObject2.data.templateContents;
                        // 取得ファイルデータを読み込む
                        // ドキュメントの作成
                        var tempdocument = FileHelper.loadDocumentAnyway(content);
                        if(tempdocument == null) return;
                        var command = new ReplaceTemplateCommand(design, tempdocument, isKeepRatio, designRotate, () => {});
                        design.undoRedoManager.do(command);
                        // アンドゥリドゥマネージャはクリアする
                        design.undoRedoManager.init();
                        // setDesignし直さないと回転が反映しない
                        document.pageList[0].getSurface(document.isReverseSurface).setDesign(0, design);
                        if(tempdocument.useInsertion)
                        {
                            // 差し込みを適用する
                            document.useInsertion = true;
                            document.insertionData = tempdocument.insertionData;
                        }

                        var categoryId = jsonObject2.data.templateCategoryId;
                        var hierarchy = jsonObject2.data.hierarchy;
                        completion(document, product, paper, categoryId, hierarchy);
                    }
                    catch(e2)
                    {
                        DebugHelper.trace("error" + e2);
                        error();
                    }
                },
                () =>
                {
                    DebugHelper.trace("request error");
                    error();
                });
            }
            catch(e1)
            {
                DebugHelper.trace(e1);
                error();
            }
        },
        () =>
        {
            error();
        });
    }

    public static applyTemplateToDocument(doc : Document, templateId : number, isKeepRatio : boolean = false, designRotate : number = 0,
        completion : (() => void) | null = null, error : (() => void) | null = null)
    {
        var currentPage = doc.pageList[doc.currentPageIndex];
        var currentSurface = currentPage.getSurface(doc.isReverseSurface);
        var currentDesign = currentSurface.getDesign(currentPage.currentDesignPosition);
        if(currentDesign == null)
        {
            // デザインがない場合作る
            currentSurface.createNewDesign(currentPage.currentDesignPosition);
        }

        if(templateId == 0)
        {
            if(completion) completion();
            return;
        }

        var postData = { "id" : "" + templateId };
        // urlからテキストを得る
        RequestHelper.get("get_template_new_content", postData, (resp) =>
        {
            try
            {
                var currentDesign = currentSurface.getDesign(currentPage.currentDesignPosition);
                if(currentDesign != null)
                {
                    // レスポンスをパース
                    var jsonObj = JSON.parse(resp);
                    // コンテンツ取得
                    var content = jsonObj.data.templateContents;
                    // 取得ファイルデータを読み込む
                    // ドキュメントの作成
                    var tempdocument = FileHelper.loadDocumentAnyway(content);
                    if(tempdocument == null) return;
                    var command = new ReplaceTemplateCommand(currentDesign, tempdocument, isKeepRatio, designRotate, () => {});
                    currentDesign.undoRedoManager.do(command);
                    // アンドゥリドゥマネージャはクリアする
                    currentDesign.undoRedoManager.init();
                    // setDesignし直さないと回転が反映しない
                    currentSurface.setDesign(currentPage.currentDesignPosition, currentDesign);

                    if(completion) completion();
                }
            }
            catch(e)
            {
                DebugHelper.trace("error" + e);
                if(error) error();
            }
        },
        () =>
        {
            DebugHelper.trace("request error");
            if(error) error();
        });
    }

    public static getProductAndPaperFromPaperCode(localProductCategoryList : Array<ProductCategory>, paperCode : string, completion : (product : Product, paper : Paper, categoryId : number, hierarchy : number) => void, error : () => void)
    {
        // メイン処理
        var process = (categoryList : Array<ProductCategory>) =>
        {
            // リストからProduct, Paper取得
            var productAndPaper = this.getProductByProductCode(categoryList, paperCode);
            if(productAndPaper)
            {
                var product = productAndPaper.product;
                var paper = productAndPaper.paper;
                var defaultCategoryId = paper.defaultTemplateCategoryId > 0 ? paper.defaultTemplateCategoryId : product.productCategoryId;
                var defaultHierarchy = paper.defaultTemplateCategoryId > 0 ? paper.defaultTemplateHierarchy : 0;
                completion(product, paper, defaultCategoryId, defaultHierarchy);
            }
            else
            {
                error();
            }
        }

        var postData = { "searchWord" : paperCode };
        RequestHelper.get("get_product_category_list", postData, resp =>
        {
            try
            {
                // レスポンスをパース
                var jsonObj = JSON.parse(resp);
                // カテゴリリスト取得
                var categoryList : Array<ProductCategory> = jsonObj.data.productCategoryList;
                process(categoryList);
            }
            catch(e)
            {
                DebugHelper.trace(e)

                // 通信失敗したらローカルを使う
                DebugHelper.trace("getProductAndPaperFromPaperCode use local data.");
                process(localProductCategoryList);
            }
        }, () =>
        {
            // 通信失敗したらローカルを使う
            DebugHelper.trace("getProductAndPaperFromPaperCode use local data.");
            process(localProductCategoryList);
        });
    }

    private static getProductByProductCode(productCategoryList : Array<ProductCategory>, productCode : string) : { product : Product, paper : Paper } | null
    {
        for(var i = 0; i < productCategoryList.length; ++i)
        {
            var productCategory = productCategoryList[i];
            var productList = productCategory.productList;
            for(var j = 0; j < productList.length; ++j)
            {
                var product = productList[j];
                var paperList = product.paperList;
                for(var k = 0; k < paperList.length; ++k)
                {
                    var paper = paperList[k];
                    if(paper.code == productCode)
                    {
                        return { product : product, paper : paper };
                    }
                }
            }
        }

        return null;
    }

    // TODO 使ってない
    private static getTemplateCategoryFromList(templateCategoryList : Array<TemplateCategory>, id : number)
    {
        for(var i = 0; i < templateCategoryList.length; ++i)
        {
            if(templateCategoryList[i].id == id) { return templateCategoryList[i]; }
        }

        return new TemplateCategory();
    }

    // URLからクエリを取得する
    public static getQueryFromUrl(url : string)
    {
        var query = {};
        var uri = url.split('?');
        if(uri.length == 2)
        {
            var queryString = uri[1];
            var queryUnits = queryString.split('&');
            for(var i = 0; i < queryUnits.length; ++i)
            {
                var queryUnit = queryUnits[i];
                var temp = queryUnit.split('=');
                if(temp.length == 2)
                {
                    var key = temp[0];
                    var value = temp[1];

                    // 値の中に '#/' or '#' が入っていた場合は削除する
                    if(value.indexOf('#/') >= 0)
                    {
                        value = value.substr(0, value.indexOf('#/'))
                    }
                    if(value.indexOf('#') >= 0)
                    {
                        value = value.substr(0, value.indexOf('#'))
                    }

                    query[key] = value;
                }
            }
        }

        return query;
    }
}
